import AbstractModel from '../AbstractModel';

class DailyCheckProceduresOperationsLabelsModel extends AbstractModel {}

export default DailyCheckProceduresOperationsLabelsModel;
